<app-external-link
  [link]="link()"
  [underline]="false">
  <div class="hover:text-primary">{{ text() }}</div>
</app-external-link>
